<template>
  <bm-control v-bind="$attrs" :read-only-value="'test'">
    <slot v-bind="$attrs" />
    <div
      v-if="errorMessages.length > 0"
      class="v-messages theme--light error--text"
    >
      <div class="v-messages__wrapper">
        <div class="v-messages__message">
          {{ errorMessages[0] }}
        </div>
      </div>
    </div>
  </bm-control>
</template>

<script lang="ts">
import BmControl from "@/components/controls/input/BmControl.vue";
import type { PropType } from "vue";
import type Vue from "vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmCheckboxGroup",
  components: { BmControl },
  inheritAttrs: false,
  props: {
    errorMessages: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  data() {
    return {
      check: this,
      checkboxes: [] as any[],
    };
  },
  methods: {
    register(checkbox: Vue) {
      checkbox.$on("change", this.onCheckboxChange);
      this.checkboxes.push(checkbox);
    },
    unregister(checkbox: Vue) {
      checkbox.$off("change", this.onCheckboxChange);

      const index = this.checkboxes.findIndex((r) => r === checkbox);

      /* istanbul ignore else */
      if (index > -1) this.checkboxes.splice(index, 1);
    },
    onCheckboxChange() {
      // if (this.$refs.vinput.disabled) return;
      // this.$refs.vinput.hasInput = true;
      // this.$nextTick(this.$refs.vinput.validate);
    },
  },
});
</script>
